import { firestore } from "common/Firebase";
import BatchService from "common/services/BatchService";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import { CompositionStore } from "modules/composition/CompositionStore";
import { BenchCompositionFile } from "modules/composition/models/BenchCompositionFile";
import { WBSPropertiesStore } from "modules/WBS/WBSPropertiesStore";
import { subtract, sum, times } from "utils/DecimalUtils";
import axios from "axios";

class Service {
  async getBenchCompositionFile(id) {
    try {
      let data = await axios.post(
        // "http://localhost:8000/getRateLibraryInformations",
        `${process.env.REACT_APP_GET_RATELIBRARY_INFORMATIONS}`,
        { id: id }
      );

      if (data) {
        let fileModel = {
          description: data.data.description,
          file: data.data.file,
          name: data.data.name,
          status: data.data.status,
          type: data.data.type,
          publicLibrary: data.data.publicLibrary,
          location: data.data.location,
        };

        return new FirebaseDocument<BenchCompositionFile>(id, fileModel);
      }
    } catch (error) {
      CompositionStore.lastIdLoaded = id;
      console.log("Erro ao recuperar composição: " + error.message);
      return null;
    }
    return null;
  }
  async getRootGroups(id, array) {
    let file = await firestore
      .collection("rateLibraryGroups")
      .where("file.id", "==", id)
      .where("parentId", "==", "")
      .get();
    for (let doc of file.docs) {
      let data = doc.data();
      if (data) array.push({ id: doc.id, data });
    }
  }

  async getGroupsByParent(id, array) {
    let file = await firestore
      .collection("rateLibraryGroups")
      .where("parentId", "==", id)
      .get();
    for (let doc of file.docs) {
      let data = doc.data();
      if (data) array.push({ id: doc.id, data });
    }
  }

  async getTaskById(id) {
    let file = await firestore.collection("rateLibraryTasks").doc(id).get();
    let data = file.data();
    if (data) return { id: file.id, data };
    return false;
  }

  /** Busca as composições a partir do ID do grupo na coleção
   * de rateLibraryTasks.
   */
  async getTasksByGroup(groupId: string) {
    let file = await firestore
      .collection("rateLibraryTasks")
      .where("group.id", "==", groupId)
      .get();
    let data = file.docs.map((doc) => {
      return { id: doc.id, data: doc.data() };
    });
    return data;
  }

  async getTasksByFile(fileId) {
    let array: any[] = [];
    let file = await firestore
      .collection("rateLibraryTasks")
      .where("file.id", "==", fileId)
      .get();
    for (let doc of file.docs) {
      let data = doc.data();
      if (data) array.push({ id: doc.id, data: data });
    }
    return array;
  }

  async getResources(fileId) {
    let array: any = [];
    let file = await firestore
      .collection("rateLibraryTasks")
      .where("file.id", "==", fileId)
      .where("type", "==", "RESOURCE")
      .get();
    for (let doc of file.docs) {
      let data = doc.data();
      if (data) array.push({ id: doc.id, data: data });
    }
    // Ordena o arry em ordem alfabética do campo description
    array.sort(function (a, b) {
      if (a.data.description > b.data.description) {
        return 1;
      }
      if (a.data.description < b.data.description) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  array: any = [];
  actions = new Array();
  costEdit(allRows, editTaskId, unitCost) {
    const rules = WBSPropertiesStore.getRules(2);
    let update: any = {};
    let diff;
    let editAtual = editTaskId;
    let lista = allRows.filter((el) => {
      for (let index = 0; index < el.data.compositionList.length; index++) {
        if (el.data.compositionList[index] == editAtual) {
          let doc = firestore.collection("rateLibraryTasks").doc(el.id);
          let totalCost = parseFloat(
            el.data.composition[index].totalCost.toString().replace(",", ".")
          );
          let coefficient = parseFloat(
            el.data.composition[index].coefficient.toString().replace(",", ".")
          );
          diff = subtract(times(coefficient, unitCost, rules), totalCost);
          let newTotalCost = sum(totalCost, diff, rules);
          el.data.composition[index].unityCost = unitCost;
          el.data.composition[index].totalCost = newTotalCost;
          let compTotalCost = parseFloat(
            el.data.totalCost.toString().replace(",", ".")
          );
          let newCompTotalCost = sum(compTotalCost, diff, rules);
          el.data.totalCost = newCompTotalCost;
          update = el.data;
          if (CompositionStore.rateTask) {
            if (el.id == CompositionStore.rateTask.id)
              CompositionStore.rateTask.data = el.data; // atualiza o CompositionStore.rateTask
          }
          if (CompositionStore.tasks) {
            CompositionStore.tasks.map((task) => {
              if (task.id == el.id) task.data = el.data;
            }); // atualiza o CompositionStore.tasks
          }
          this.actions.push({
            type: "update",
            args: [doc, { ...update }],
          });
          return true;
        }
      }
      return false;
    });
    //
    if (lista.length != 0) this.array.push(lista);
    //
    for (let index = 0; index < lista.length; index++) {
      let li = this.costEdit(
        allRows,
        lista[index].id,
        lista[index].data.totalCost
      );
    }
    //
    return [lista, this.actions, this.array];
  }

  getTasksInline(allRows, tasksId, id, quantity, unitCost, editTask) {
    const rules = WBSPropertiesStore.getRules(2);
    let actions = new Array();
    let update: any = {};
    let lvlTasks = tasksId.length;
    let i = lvlTasks - 1;
    let diff;
    let totalUnitCost;
    let referenceid = editTask.id;
    let newList: any = [];

    let lista = allRows.filter((el) => {
      for (let index = 0; index < tasksId.length; index++) {
        if (el.id == tasksId[index]) {
          diff = 0;
          el.data.composition.forEach((element) => {
            if (element.reference == referenceid) {
              let totalCost = parseFloat(
                element.totalCost.toString().replace(",", ".")
              );
              let coefficient =
                editTask.id == element.reference
                  ? quantity
                  : parseFloat(
                      element.coefficient.toString().replace(",", ".")
                    );
              let unityCost =
                editTask.id == element.reference
                  ? parseFloat(element.unityCost.toString().replace(",", "."))
                  : totalUnitCost;
              diff = subtract(times(coefficient, unityCost, rules), totalCost);
              let newTotalCost = sum(totalCost, diff, rules);
              if (editTask.id == element.reference) {
                element.coefficient = coefficient;
              } else {
                element.unityCost = unityCost;
              }
              element.totalCost = newTotalCost;
            }
          });
          let totalCost = parseFloat(
            el.data.totalCost.toString().replace(",", ".")
          );
          referenceid = tasksId[index];
          let newTotalCost = sum(totalCost, diff, rules);
          totalUnitCost = newTotalCost;
          el.data.totalCost = newTotalCost;
          let doc = firestore.collection("rateLibraryTasks").doc(el.id);
          update = el.data;
          if (el.id == CompositionStore.rateTask.id)
            CompositionStore.rateTask.data = el.data; // atualiza o CompositionStore.rateTask
          CompositionStore.tasks.map((task) => {
            if (task.id == el.id) task.data = el.data;
          }); // atualiza o CompositionStore.tasks
          actions.push({
            type: "update",
            args: [doc, { ...update }],
          });
        }
      }
    });
    return [newList, actions];
  }

  batch(actions) {
    return BatchService.apply(actions);
  }
}

let CompositionService = new Service();
export { CompositionService };



// WEBPACK FOOTER //
// ./src/modules/composition/CompositionService.tsx